export default __webpack_public_path__ + "45d97de03c346ad506321b92f3ed5cd3.png";